import { cn } from '@poseidon/components/cn';
import { Arrows } from '@poseidon/components/StrokeIcons';

import type { SequencePreStep } from '~/components/Sequence/sequenceSteps';

/**
 * A read-only "before outreach" node — part of the automatic journey (research / dossier / qualify /
 * enroll), shown for context above the editable steps. Dashed + muted so it clearly isn't an
 * editable step. Click to expand its sub-steps.
 */
export function SequencePreStepNode({
  preStep,
  expanded,
  onToggle,
}: {
  preStep: SequencePreStep;
  expanded: boolean;
  onToggle: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className={cn(
        'flex h-9 items-center gap-2 rounded-full border border-dashed px-3 text-xs font-medium transition-colors [&>svg]:size-4',
        expanded
          ? 'border-blue-400 bg-blue-50 text-blue-600 dark:border-blue-500 dark:bg-blue-500/10 dark:text-blue-300'
          : 'border-lynch-300 bg-slate-100/70 text-lynch-500 hover:border-lynch-400 hover:text-lynch-600 dark:border-slate-600 dark:bg-slate-800/50 dark:text-lynch-400 dark:hover:text-lynch-300',
      )}>
      {preStep.icon}
      {preStep.label}
      <Arrows.ChevronRight className={cn('size-3.5 transition-transform', expanded && 'rotate-90')} />
    </button>
  );
}
